<template>
    <Dialog v-model:open="open">
        <DialogTrigger as-child>
            <slot />
        </DialogTrigger>
        <DialogContent class="sm:max-w-[425px]">
            <DialogHeader>
                <DialogTitle> {{ $t("teams.invite_to_team") }}</DialogTitle>
            </DialogHeader>
            <form @submit.prevent="inviteToTeam">
                <div class="grid gap-4 py-4">
                    <div class="grid w-full max-w-sm items-center gap-1.5">
                        <Label for="domain">{{
                            $t("teams.member_email")
                        }}</Label>
                        <Input
                            id="email"
                            v-model="email"
                            type="email"
                            placeholder="example@example.test"
                        />
                    </div>
                    <div class="grid w-full max-w-sm items-center gap-1.5">
                        <Label for="domain">{{
                            $t("teams.member_role")
                        }}</Label>

                        <select
                            v-model="role"
                            class="focus-visible:ring-iron-950 dark:bg-iron-950 dark:ring-offset-iron-950 flex h-10 w-full rounded-lg border border-iron-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-iron-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-iron-800 dark:placeholder:text-iron-400 dark:focus-visible:ring-iron-300"
                        >
                            <option value="viewer">Viewer</option>
                            <option value="editor">Editor</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>
                </div>
                <DialogFooter>
                    <ZButton class="ml-4" type="submit">
                        {{ $t("teams.invite_to_team") }}
                    </ZButton>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import ZButton from "../../Atomic/Button.vue";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";

const props = defineProps({
    team: {
        type: Object,
        required: true,
    },
});

const open = ref(false);
const email = ref("");
const role = ref("viewer");

async function inviteToTeam() {
    router.post(
        route("team-members.store", {
            team: props.team.id,
        }),
        {
            email: email.value,
            role: role.value,
        },
        {
            onFinish: () => {
                open.value = false;
            },
        },
    );
}
</script>
